import { render, staticRenderFns } from "./edit-content.component.vue?vue&type=template&id=29aa3776"
import script from "./edit-content.component.vue?vue&type=script&lang=js"
export * from "./edit-content.component.vue?vue&type=script&lang=js"
import style0 from "./edit-content.component.vue?vue&type=style&index=0&id=29aa3776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports